import { LayoutCssGrid } from "./LayoutCssGrid";
import { LayoutFlexboxGrid } from "./LayoutFlexboxGrid";
export const LayoutGridComponents = {
    FlexboxGrid: LayoutFlexboxGrid,
    CssGrid: LayoutCssGrid,
};
//# sourceMappingURL=LayoutGridComponents.js.map